(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["erb-date-property"] && !Shopify.designMode) return;
  try {
    class ErbDatePropertyGuard extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input[type="date"]');
      if (!this.input) return;

      const formId = this.input.getAttribute('form');
      this.form = formId ? document.getElementById(formId) : this.input.closest('form');
      if (!this.form) return;

      this.button = this.form.querySelector('[ref="addToCartButton"]');
      if (!this.button) return;

      this.handleClick = this.handleClick.bind(this);
      this.button.addEventListener('click', this.handleClick, true);
    }

    disconnectedCallback() {
      if (this.button) {
        this.button.removeEventListener('click', this.handleClick, true);
      }
    }

    handleClick(event) {
      if (!this.form.checkValidity()) {
        event.preventDefault();
        event.stopPropagation();
        this.form.reportValidity();
      }
    }
  }

  if (!customElements.get('date-property-guard')) {
    customElements.define('date-property-guard', ErbDatePropertyGuard);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["erb-faqs"] && !Shopify.designMode) return;
  try {
    class ErbFaqs extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (event) => {
        const summary = event.target.closest('.erb-faqs__question');
        if (!summary) return;
        event.preventDefault();
        const item = summary.closest('.erb-faqs__item');
        item.toggleAttribute('open');
      });
    }
  }

  if (!customElements.get('erb-faqs')) {
    customElements.define('erb-faqs', ErbFaqs);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["erb-pseudo-collection"] && !Shopify.designMode) return;
  try {
    class ErbPseudoCollection extends HTMLElement {
    connectedCallback() {
      const link = this.dataset.cardLink;
      if (!link) return;

      const target = this.dataset.cardLinkTarget || '_self';
      this.querySelectorAll('.erb-pseudo-collection__card-link').forEach((anchor) => {
        anchor.href = link;
        if (target === '_blank') {
          anchor.target = '_blank';
          anchor.rel = 'noopener';
        }
      });
    }
  }

  if (!customElements.get('erb-pseudo-collection')) {
    customElements.define('erb-pseudo-collection', ErbPseudoCollection);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["erb-reviews-carousel"] && !Shopify.designMode) return;
  try {
    class ErbReviewsCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.erb-reviews-carousel__track');
      this.trackWrapper = this.querySelector('.erb-reviews-carousel__track-wrapper');
      this.slides = Array.from(this.querySelectorAll('.erb-reviews-carousel__slide'));
      this.dots = Array.from(this.querySelectorAll('.erb-reviews-carousel__dot'));
      this.prevButton = this.querySelector('.erb-reviews-carousel__arrow--prev');
      this.nextButton = this.querySelector('.erb-reviews-carousel__arrow--next');
      this.index = 0;

      if (this.prevButton) {
        this.prevButton.addEventListener('click', () => this.go(this.index - 1));
      }

      if (this.nextButton) {
        this.nextButton.addEventListener('click', () => this.go(this.index + 1));
      }

      this.dots.forEach((dot, i) => {
        dot.addEventListener('click', () => this.go(i));
      });

      if (this.trackWrapper) {
        this.trackWrapper.addEventListener('touchstart', (event) => this.handleTouchStart(event), { passive: true });
        this.trackWrapper.addEventListener('touchend', (event) => this.handleTouchEnd(event), { passive: true });
      }

      this.update();
    }

    handleTouchStart(event) {
      this.touchStartX = event.changedTouches[0].clientX;
    }

    handleTouchEnd(event) {
      if (this.touchStartX === undefined) return;

      const swipeThreshold = 40;
      const deltaX = event.changedTouches[0].clientX - this.touchStartX;
      this.touchStartX = undefined;

      if (deltaX > swipeThreshold) {
        this.go(this.index - 1);
      } else if (deltaX < -swipeThreshold) {
        this.go(this.index + 1);
      }
    }

    go(index) {
      const count = this.slides.length;
      if (count === 0) return;
      this.index = Math.min(Math.max(index, 0), count - 1);
      this.update();
    }

    update() {
      if (this.track) {
        this.track.style.transform = `translateX(-${this.index * 100}%)`;
      }

      this.dots.forEach((dot, i) => {
        const active = i === this.index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });

      if (this.prevButton) {
        this.prevButton.disabled = this.index === 0;
      }

      if (this.nextButton) {
        this.nextButton.disabled = this.index === this.slides.length - 1;
      }
    }
  }

  if (!customElements.get('erb-reviews-carousel')) {
    customElements.define('erb-reviews-carousel', ErbReviewsCarousel);
  }
  } catch(e) { console.error(e); }
})();

})();
